export const APP_INIT = "appInit"
export const APP_FETCH_LANGUAGES = "appFetchLanguages"
export const APP_FETCH_EDUCATION_LEVELS = "appFetchEducationLevels"